import { useDispatch, useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import RouteActions from 'app/shared/flux/actions/RouteActions';
import dateUtils from 'app/shared/utils/dateUtils';
import { useYieldCallback } from '@zillow/yield-callback';
import IconCuckoo from 'images/icons/cuckoo.svg';
import * as styles from './expiredListingBanner.styles';

type ListingHistory = {
  deactivated?: { date: number; ago: string };
};

export const ExpiredListingBanner = () => {
  const dispatch = useDispatch();
  const listing = useSelector((state: RootReduxState) => state.currentListingDetails?.currentListing);
  const yieldNavigate = useYieldCallback((path: string) => {
    window.router.transitionTo(path);
  });

  if (!listing || listing.active !== false) return null;

  const history = listing.history as unknown as ListingHistory | undefined;
  const areaPath = dispatch(RouteActions.getAreaPath()) as unknown as string;

  const handleExploreClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    yieldNavigate(areaPath);
  };

  const deactivatedDate = history?.deactivated?.ago ? dateUtils.formatDateMmddyy(history.deactivated.date) : null;

  return (
    <div className={styles.container} role="status">
      <img src={IconCuckoo} alt="" aria-hidden="true" className={styles.cuckooIcon} />
      <div className={styles.textContent}>
        <span className={styles.messageText}>
          {deactivatedDate
            ? `This pad was taken off the market on ${deactivatedDate}.`
            : 'This pad is no longer available.'}
        </span>
        <a href={areaPath} onClick={handleExploreClick} className={styles.exploreLink}>
          Explore listings in the same area.
        </a>
      </div>
    </div>
  );
};
